import type { MusicService } from '../types';
import { ImporterID, MusicAPIIntegrationID } from '../ids';
import { musicServiceMessages } from '../messages';

export const pandora: MusicService = {
  id: 'pandora',
  name: 'Pandora',
  shortName: 'Pandora',
  isSupported: true,
  isComingSoon: false,
  areStatsSupported: false,
  areStatsComingSoon: true,
  isAlbumTransferSupported: false,
  color: {
    primary: '#0089FC',
    label: '#0463B1',
    background: '#677380',
  },
  importerID: ImporterID.Pandora,
  musicAPIID: MusicAPIIntegrationID.Pandora,
  linkType: 'pandora',
  limits: {
    tracksPerPlaylist: 5000,
  },
  assets: {
    logo: { light: 'pandora-light.svg', dark: 'pandora-dark.svg' },
    logoPadding: { light: 'pandora-light-padding.svg', dark: 'pandora-dark-padding.svg' },
    logoColor: { light: 'pandora-color-light.svg', dark: 'pandora-color-dark.svg' },
    logoColorPadding: {
      light: 'pandora-color-light-padding.svg',
      dark: 'pandora-color-dark-padding.svg',
    },
    logoOnBackground: 'pandora-dark.svg',
  },
  whatIsDescription: musicServiceMessages.pandoraWhatIs,
};
